
import * as requestPromise from 'request-promise'
import { appConfig } from '../firebase/config';
import { InvitationsResponse } from '../types/blueprint';
import { FirebaseClient } from '../firebase/FirebaseClient';

const HOST = process.env.HOST || appConfig.zimiserviceConfig.baseUrl;
// const PORT = process.env.PORT || 80;
const BASEURL = 'https://' + HOST  //+ (PORT !== '80' ? ':' + PORT : '');

export const getInvitations = (jwt: string): Promise<InvitationsResponse> => {
    return new Promise<any>((resolve, reject) => {
        requestPromise.get({
            headers: { 'Authorization': 'Bearer ' + jwt },
            url: BASEURL + '/api/group/invitations',
            resolveWithFullResponse: true,
        })
            .then((ret: any) => {
                const body = JSON.parse(ret.body);
                resolve(body);
            })
            .catch((err: any) => {
                reject(err);
            });
    });
};

export enum UpdateInvitationType {
    ACCEPT,
    REJECT
}

export const updateInvitation = (invitationToken: string, updateType: UpdateInvitationType): Promise<InvitationsResponse> => {
    return new Promise<any>((resolve, reject) => {
        FirebaseClient.getInstance().getFirebaseAuth().currentUser?.getIdToken()
            .then(jwt => {

                let updateUrl = '';
                switch (updateType) {
                    case UpdateInvitationType.ACCEPT:
                        updateUrl = '/api/group/' + invitationToken + '/acceptInvitation';
                        break;
                    case UpdateInvitationType.REJECT:
                        updateUrl = '/api/group/' + invitationToken + '/rejectInvitation';
                        break;
                }
                requestPromise.post({
                    headers: { 'Authorization': 'Bearer ' + jwt },
                    url: BASEURL + updateUrl,
                    resolveWithFullResponse: true,
                })
                    .then((ret: any) => {
                        // const body = JSON.parse(ret.body);
                        resolve(ret);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            })
            .catch(err => {
                reject(err)
            })
    })
};